// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dma-list-container {
  height: auto;
  max-height: min(45vh, 555px);
  min-height: 200px;
  overflow-y: auto;
}

.view-more-loc {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.loc-popover-title {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.close-icon-more-locations:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.ant-popover .ant-popover-content ::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
}

/* Track */
.ant-popover .ant-popover-content ::-webkit-scrollbar-track {
  box-shadow: unset !important;
  border-radius: 10px;
}

/* Handle */
.ant-popover .ant-popover-content ::-webkit-scrollbar-thumb {
  background: #ea8c9e;
  border-radius: 10px;
}

/* Handle on hover */
.ant-popover .ant-popover-content ::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}
.dma-list-alphabetics-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10;
  overflow-y: scroll;
  max-height: min(45vh, 555px);
  min-height: 200px;
}
.alphabet-item {
  font-size: 13px;
  color: #8e9190;
  font-weight: 600;
}
.alphabet-list {
  width: 50px;
}

.alphabet-item {
  font-family: Roboto;
  cursor: pointer;
  justify-content: center;
  text-align: center;
  transition: color 0.3s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.selected-alphabet {
  color: #d2042d !important;
  font-weight: bold;
}

.filter-div-at-map-section {
  width: 178px;
  height: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 7px;
  border: #c8cccb solid 1px;
  background-color: #fff;
  cursor: pointer;
}

.product-placement-container {
  position: none;
}
.map-placement-container {
  position: relative;
}

.map-placement {
  position: absolute;
  display: flex;
  z-index: 1000;
  top: var(--popover-top, 1);
  left: var(--popover-left, 0);
  transition: all 0.2s ease;
}

.product-placement {
  position: absolute;
  display: flex;
  z-index: 1000;
  top: var(--popover-top, 4rem);
  left: var(--popover-left, 17.5vw);
  transition: all 0.2s ease;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.location-list-view-text {
  display: inline-block;
  margin-right: 8px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 27px;
}

.location-list-view-span {
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  color: #d2042d;
  text-decoration: underline;
}
.location-list-card.ant-card .ant-card-body {
  padding-top: 5px !important;
  border-radius: 0 0 8px 8px;
}
@media (max-width: 1440px) {
  .product-placement {
    position: absolute;
    display: flex;
    z-index: 1000;
    top: var(--popover-top, 4rem);
    left: var(--popover-left, 14rem);
    transition: all 0.2s ease;
  }
  .map-placement {
    position: absolute;
    display: flex;
    z-index: 1000;
    top: var(--popover-top, 1);
    left: var(--popover-left, 0);
    transition: all 0.2s ease;
  }
}
@media (max-width: 1024px) {
  .product-placement {
    position: absolute;
    display: flex;
    z-index: 1000;
    top: var(--popover-top, -30vh);
    left: var(--popover-left, 12vw);
    transition: all 0.2s ease;
  }
  .map-placement {
    position: relative;
    display: flex;
    z-index: 1000;
    top: var(--popover-top, 1);
    left: var(--popover-left, 0);
    transition: all 0.2s ease;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/locationlistpopover/LocationList.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF","sourcesContent":[".dma-list-container {\n  height: auto;\n  max-height: min(45vh, 555px);\n  min-height: 200px;\n  overflow-y: auto;\n}\n\n.view-more-loc {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.loc-popover-title {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.close-icon-more-locations:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.ant-popover .ant-popover-content ::-webkit-scrollbar {\n  width: 5px !important;\n  height: 10px !important;\n}\n\n/* Track */\n.ant-popover .ant-popover-content ::-webkit-scrollbar-track {\n  box-shadow: unset !important;\n  border-radius: 10px;\n}\n\n/* Handle */\n.ant-popover .ant-popover-content ::-webkit-scrollbar-thumb {\n  background: #ea8c9e;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n.ant-popover .ant-popover-content ::-webkit-scrollbar-thumb:hover {\n  background: #b30000;\n}\n.dma-list-alphabetics-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10;\n  overflow-y: scroll;\n  max-height: min(45vh, 555px);\n  min-height: 200px;\n}\n.alphabet-item {\n  font-size: 13px;\n  color: #8e9190;\n  font-weight: 600;\n}\n.alphabet-list {\n  width: 50px;\n}\n\n.alphabet-item {\n  font-family: Roboto;\n  cursor: pointer;\n  justify-content: center;\n  text-align: center;\n  transition: color 0.3s ease;\n  cursor: pointer;\n  user-select: none;\n}\n\n.selected-alphabet {\n  color: #d2042d !important;\n  font-weight: bold;\n}\n\n.filter-div-at-map-section {\n  width: 178px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border-radius: 7px;\n  border: #c8cccb solid 1px;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.product-placement-container {\n  position: none;\n}\n.map-placement-container {\n  position: relative;\n}\n\n.map-placement {\n  position: absolute;\n  display: flex;\n  z-index: 1000;\n  top: var(--popover-top, 1);\n  left: var(--popover-left, 0);\n  transition: all 0.2s ease;\n}\n\n.product-placement {\n  position: absolute;\n  display: flex;\n  z-index: 1000;\n  top: var(--popover-top, 4rem);\n  left: var(--popover-left, 17.5vw);\n  transition: all 0.2s ease;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.location-list-view-text {\n  display: inline-block;\n  margin-right: 8px;\n  cursor: pointer;\n  margin-top: 20px;\n  margin-left: 27px;\n}\n\n.location-list-view-span {\n  font-family: Roboto;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  color: #d2042d;\n  text-decoration: underline;\n}\n.location-list-card.ant-card .ant-card-body {\n  padding-top: 5px !important;\n  border-radius: 0 0 8px 8px;\n}\n@media (max-width: 1440px) {\n  .product-placement {\n    position: absolute;\n    display: flex;\n    z-index: 1000;\n    top: var(--popover-top, 4rem);\n    left: var(--popover-left, 14rem);\n    transition: all 0.2s ease;\n  }\n  .map-placement {\n    position: absolute;\n    display: flex;\n    z-index: 1000;\n    top: var(--popover-top, 1);\n    left: var(--popover-left, 0);\n    transition: all 0.2s ease;\n  }\n}\n@media (max-width: 1024px) {\n  .product-placement {\n    position: absolute;\n    display: flex;\n    z-index: 1000;\n    top: var(--popover-top, -30vh);\n    left: var(--popover-left, 12vw);\n    transition: all 0.2s ease;\n  }\n  .map-placement {\n    position: relative;\n    display: flex;\n    z-index: 1000;\n    top: var(--popover-top, 1);\n    left: var(--popover-left, 0);\n    transition: all 0.2s ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
